import { administrationRequests } from "api/administrationApi";
import AutoPickSelectInput from "server/components/Fields/AutoPickSelectInput";
import React from "react";
import { ReferenceInput, required } from "react-admin";

const BirthCountryDistributionByCourse = ({ handleParamChange }) => {
  return (
    <ReferenceInput
      reference={administrationRequests.getStructuralUnitsSelect()}
      source="structuralUnitId"
      filter={{ filterByUser: true }}
    >
      <AutoPickSelectInput
        source="structuralUnitId"
        label="Факултет"
        validate={required()}
        emptyText={false}
        onValueChange={v => handleParamChange("structuralUnitId", v)}
      />
    </ReferenceInput>
  );
};

export default BirthCountryDistributionByCourse;
